import { capitalizeWords } from "../../utils/util";

function getMonthName(monthNumber) {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  // Validate the month number
  if (monthNumber >= 1 && monthNumber <= 12) {
    return monthNames[monthNumber - 1];
  } else {
    return "Invalid month number";
  }
}
function formatDate(date) {
  // 1. Null or undefined → return empty array
  if (!date) {
    return ["", "", ""];
  }

  // 2. Ensure it's a string
  if (typeof date !== "string") {
    return ["", "", ""];
  }

  // 3. Must contain `T` for datetime format
  if (!date.includes("T")) {
    return ["", "", ""];
  }

  // 4. Safe parsing
  const parts = date.split("T")[0].split("-"); // ["2025", "12", "15"]

  return [
  parts[0] || "", // year
  parts[1] || "", // month
  parts[2] || "" // day
  ];
}



const EscortLeaveCard = ({
  data,
  toDate,
  fromDate,
  orderPlaceDate,
  doctorName,
  onViewCertificate,
  translationMap,
  isMobile,
  isSignaturePresent
}) => {
  let formatToDate = toDate ? formatDate(toDate) : null;

  let formatFromDate = formatDate(fromDate);
  let formatOrderPlaceDate = formatDate(orderPlaceDate);
  return <div className="Sick_Leave_Main_Wrapper">
        <div className="Sick_leave_white_box">
            <div className="sick_inner_box1">
                <div className="date_box">
                    <h6 className="Gray_Title">
                        {getMonthName(formatOrderPlaceDate[1]).toUpperCase().slice(0, 3)}
                        <b>{formatOrderPlaceDate[2]}</b>
                        {formatOrderPlaceDate[0]}
                    </h6>
                </div>
                <div className="content_box">
                    <h6 className="name_txt">{capitalizeWords(doctorName)}</h6>
                    <ul className="detail_ul_box">
                        <li>
                            <p>
                                <span>{translationMap?.valid_from}: &nbsp;</span>
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                <a href="javascript:void(0);">{`${getMonthName(formatFromDate[1])} ${formatFromDate[2]} ${formatFromDate[0]}`}</a>
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>{translationMap?.to}: &nbsp;</span>
                                {/*<a href="javascript:void(0);">{`${getMonthName(formatToDate[1])} ${formatToDate[2]} ${formatToDate[0]}`}</a>*/}
                                {formatToDate ?
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url
                <a href="javascript:void(0);">
                                        {`${getMonthName(formatToDate[1])} ${formatToDate[2]} ${formatToDate[0]}`}
                                    </a> :

                // eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url
                <a href="javascript:void(0);">Until Discharge</a>
                }
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="sick_inner_box2">
                <div className="btn_innerwrap">
                    {!isMobile && <div className={
          // !isSignaturePresent ? 'disabled_btn_link' :
          "button2"}>
                        <button onClick={(e) => onViewCertificate(data, "download", e)}
            // disabled={!isSignaturePresent}
            >
                            <div className="content">
                    <span className="button-text">
                      {translationMap?.download_certificate}
                    </span>
                                <i className="fa-solid fa-download"></i>
                            </div>
                        </button>
                    </div>}

                    <button
            className={
            // !isSignaturePresent ? 'disabled_btn_link' :
            "view_btn_link"}
            onClick={() => onViewCertificate(data, "view")}
            // disabled={!isSignaturePresent}
          >
                        {translationMap?.view_certificate}
                    </button>
                </div>
            </div>
        </div>
    </div>;
};

export default EscortLeaveCard;